import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'

import helpers from '~/plugins/vuex-orm/plugins/helpers'
import ormTable from '~/plugins/vuex-orm/plugins/orm-table'
import queries from '~/plugins/vuex-orm/plugins/queries'
import VuexORMAxiosConfig from '~/plugins/vuex-orm/plugins/vuex-orm-axios-config'

import { actions } from '~/const/global'

// TODO: create automatic import of models.
import MediaObject from '~/models/system/MediaObject'
import Dialog from '~/models/system/Dialog'
import Sidebar from '~/modules/sidebar/models/Sidebar'
import Notifications from '~/modules/notifications/models/Notifications'
import User from '~/models/administration/User'
import AuthToken from '~/modules/auth/models/AuthToken'
import CurrentUser from '~/modules/auth/models/CurrentUser'
import OrganizationUsers from '~/modules/organizations/models/OrganizationUsers'
import OrganizationInvite from '~/modules/organizations/models/OrganizationInvite'
import EdsIitCheckbox from '~/modules/eds-iit-checkbox/models/EdsIitCheckbox'
import OrganizationSearch from '~/models/directories/search/OrganizationSearch'
import Shortcode from '~/modules/shortcodes/models/Shortcode'
import Snackbar from '~/modules/snackbar/models/Snackbar'
import BulkSignature from '~/modules/bulk-signature/models/BulkSignature'
import MobileDrawer from '~/modules/mobile-drawer/models/MobileDrawer'
import Guideline from '~/modules/guideline/models/Guideline'
import GalleryCategory from '~/modules/templates/models/GalleryCategory'
import Gallery from '~/modules/templates/models/Gallery'
import DocumentSidebar from '~/modules/documents/models/DocumentSidebar'
import Contact from '~/modules/contacts/models/Contact'

export const models = {
  MediaObject,
  Dialog,
  Notifications,
  Sidebar,
  User,
  AuthToken,
  CurrentUser,
  OrganizationUsers,
  OrganizationInvite,
  EdsIitCheckbox,
  OrganizationSearch,
  Shortcode,
  Snackbar,
  BulkSignature,
  MobileDrawer,
  Guideline,
  GalleryCategory,
  Gallery,
  DocumentSidebar,
  Contact
}

export const mapping = {
  MediaObject
}

function forEach(callback) {
  for (const index in models) {
    const concrete = models[index]

    callback(concrete)
  }
}

export function mapAbilities(rules, config, mock = true) {
  if (mock) {
    return mockAbilities(config)
  }

  return rules
    ? rules.map(item => {
        if (!(item.subject in mapping)) {
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.error(
              ['You need create mapping for:', item.subject].join(' ').trim(),
              'entity!'
            )
          }

          return {}
        }

        return Object.assign({}, item, { subject: mapping[item.subject][config.modelKey] })
      })
    : []
}

export function mockAbilities(config) {
  const abilities = []

  forEach(model => {
    abilities.push({ actions: Object.values(actions), subject: model[config.modelKey] })
  })

  return abilities
}

export function vuexORMPlugin(store) {
  VuexORM.use(VuexORMAxios) // <- No axios option.
  VuexORM.use(VuexORMAxiosConfig)
  VuexORM.use(helpers)
  VuexORM.use(ormTable)
  VuexORM.use(queries)

  const database = new VuexORM.Database()

  forEach(model => database.register(model))

  return VuexORM.install(database)
}
